// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"511":"51f927ff","673":"3f153c04","767":"6596611e"}[chunkId] + ".chunk.js";
};